// extracted by mini-css-extract-plugin
export var deleteIcon = "_nk-5";
export var deleteOption = "_nk-3";
export var divider = "_nk-2";
export var downloadIcon = "_nk-4";
export var drawer = "_nk-0";
export var drawerFooter = "_nk-6";
export var drawerOpen = "_nk-1";
export var highlighted = "_nk-7";
export var lighterHighlight = "_nk-8";